const e=async e=>{let{data:t}=await e.post(`/auth/mfa/totp/start`);return t};export{e as startTotpSetup};
//# sourceMappingURL=start-totp-setup.mjs.map